import {
    Users
} from 'lucide-react';

const TeamMemberCard = ({ member, isOwner }) => (
    <div className="bg-white rounded-lg border p-3 sm:p-4">
        <div className="flex items-center gap-2 sm:gap-3 mb-2 sm:mb-3">
            <div className="w-8 h-8 sm:w-12 sm:h-12 rounded-full bg-custom-blue-1/10 flex items-center justify-center">
                <Users className="w-4 h-4 sm:w-6 sm:h-6 text-custom-blue-1" />
            </div>
            <div className="flex-1 min-w-0">
                <h4 className="font-medium text-gray-900 text-sm sm:text-base truncate">{member.displayName}</h4>
                <p className="text-xs sm:text-sm text-gray-500 truncate">{member.email}</p>
            </div>
            {isOwner && (
                <span className="text-xs bg-custom-green-1/10 text-custom-green-1 px-2 py-1 rounded-full whitespace-nowrap">
                    Owner
                </span>
            )}
        </div>
    </div>
);

export default TeamMemberCard;